import setTimer from './set-timer';

export class ChangeDate {
  constructor(options) {
    this.start = new Date(options.start);
    this.end = new Date(options.end);
    this.period = options.period;
    this.timer = options.timer;
    this.selectorCounter = options.selectorCounter;
    this.data = options.data;
    this.count = Math.floor((Date.now() - this.start) / 864e5);
    this._init();
  }

  _init() {
    if (this.end == 'Invalid Date') {
      let i = this.count;

      while (i >= this.period) {
        i -= this.period;
      }

      this.start = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * i);
      this.end = new Date(
        this.start.getTime() + 24 * 60 * 60 * 1000 * this.period
      );
    }

    if (this.timer == true) {
      setTimer(this.end);
    }
  }
}
